module.exports = __webpack_public_path__ + "static/media/mini-kit.989ca183.png";